export function formatText(value: string): string {
  return value.replace(/[\d\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '')
}

export function formatNumber(value: string): string {
  return value.replace(/[^0-9]/g, '')
}

export function formatPhoneNumber(value: string): string {
  return value.replace(/[a-zA-Z]/g, '')
}